import React, { Component } from 'react';
import { createForm } from 'rc-form';
import { FormattedMessage } from 'react-intl';
import get from 'lodash/get';
import { Link } from 'react-router-dom';

import Text from 'ui/Text';
import Button from 'ui/Button';
import axios from 'utils/axios';
import Helpers from 'shared/Helpers';
import { BASE_URL } from 'utils/app-constants';
import Auth from 'shared/Auth';

class PasswordResetForm extends Component {
  constructor() {
    super();

    this.state = {
      errorMessage: '',
      successMessage: '',
      loading: false,
      resetMode: false,
      linkLoading: false,
      userInfo: null,
      requiredText: get(Auth.getLanguage(), 'local_locale') === 'fr' ? 'Champs obligatoires' : 'Required',
    };
  }

  componentDidMount() {
    const token = Helpers.extractQueryParams('token', this.props.route);

    if (token) {
      const payload = {
        token,
        should_expire_token: true,
      };

      this.setState({
        errorMessage: '',
        successMessage: '',
        loading: false,
        linkLoading: true,
        resetMode: true,
      });

      axios
        .post('/auth/password/token-authenticate', payload)
        .then((response) => {
          this.setState({
            successMessage:
              'Your token has been verified successfully. Kindly reset your password.',
            linkLoading: false,
            userInfo: response.data
          });
        })
        .catch((error) => {
          this.setState({ linkLoading: false, errorMessage: get(error, 'response.data.message', 'Your token may have expired.') });
        });
    }
  }

  resetPassword = (e) => {
    e.preventDefault();

    this.props.form.validateFields((formError, values) => {
      if (formError) {
        return;
      }

      this.setState({
        errorMessage: '',
        successMessage: '',
        loading: true,
      });

      delete values['confirm_password'];

      const payload = {
        ...values,
      };

      let token = get(this.state.userInfo, 'access_token');
      let userId = get(this.state.userInfo, 'user.id');

      axios
        .put(`/user/${userId}`, payload, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        })
        .then(() => {
          this.setState({
            successMessage: 'Password has been successfully reset. Please Log in.',
            loading: false,
          });
        })
        .catch((error) => {
          this.setState({
            loading: false,
            errorMessage: get(error, 'response.data.message') || error,
          });
        });
    });
  };

  initiateReset = (e) => {
    e.preventDefault();

    this.props.form.validateFields((formError, values) => {
      if (formError) {
        return;
      }

      this.setState({
        errorMessage: '',
        loading: true,
      });

      const payload = {
        ...values,
        locale: get(Auth.getLanguage(), 'lang'),
        base_reset_url: `${BASE_URL}/reset-password`,
      };

      axios
        .post('/auth/password/recover', payload)
        .then(() => {
          this.setState({
            successMessage: <FormattedMessage 
                              id="Form.SuccessfulResetEmail" 
                              defaultMessage="Kindly click on the reset link that was sent to the email you provided." />,
            loading: false,
          });
        })
        .catch((error) => {
          this.setState({
            loading: false,
            errorMessage: get(error, 'response.data.message') || error,
          });
        });
    });
  };

  render() {
    const { getFieldDecorator, getFieldError } = this.props.form;

    return (
      <form
        onSubmit={this.state.resetMode ? this.resetPassword : this.initiateReset}
        className="signup-form signin-form"
      >
        <div className={this.state.loading ? 'text-center waiting' : 'hidden'}>
          <Text type="explanation">Submitting Email ...</Text>
        </div>
        <div className={this.state.errorMessage ? 'alert' : 'hidden'}>
          <Text type="explanation">{this.state.errorMessage}</Text>
        </div>
        <div className={this.state.linkLoading ? 'alert warning text-center' : 'hidden'}>
          <Text type="explanation">Verifying link ...</Text>
        </div>
        <div className={this.state.successMessage ? 'alert success' : 'hidden'}>
          <Text type="explanation">{this.state.successMessage}</Text>
        </div>
        {this.state.resetMode ? (
          <div>
            <div className="signup-form__field">
              <label htmlFor="password">
                <FormattedMessage id="Form.Password" defaultMessage="Password" />
              </label>
              {getFieldDecorator('password', {
                initialValue: '',
                rules: [
                  {
                    required: true,
                    message: `${this.state.requiredText}`,
                  },
                ],
              })(<input type="password" className="signup-form__form-control" />)}
              <div className={getFieldError('password') ? 'error' : 'hidden'}>
                {(getFieldError('password') || []).join(', ')}
              </div>
            </div>
            <div className="signup-form__field">
              <label htmlFor="confirm_password">
                <FormattedMessage id="Form.ConfirmPassword" defaultMessage="Confirm Password" />
              </label>
              {getFieldDecorator('confirm_password', {
                initialValue: '',
                rules: [
                  {
                    validator: (rule, value, callback) => {
                      const form = this.props.form;
                      const firstPassword = form.getFieldValue('password');
                      const secondPassword = form.getFieldValue('confirm_password');

                      let msg = get(Auth.getLanguage(), 'local_locale') === 'fr' ? 'Pas pareil' : 'Not Similar';

                      if (!firstPassword.match(secondPassword)) {
                        callback(msg);
                      } else {
                        callback();
                      }
                    },
                  },
                ],
              })(<input type="password" className="signup-form__form-control" />)}
              <div className={getFieldError('confirm_password') ? 'error' : 'hidden'}>
                {(getFieldError('confirm_password') || []).join(', ')}
              </div>
            </div>  
          </div>        
        ) : (
            <div className="signup-form__field">
              <label htmlFor="email">
                <FormattedMessage id="Form.EmailAddress" defaultMessage="Email" />
              </label>
              {getFieldDecorator('email', {
                initialValue: '',
                rules: [
                  {
                    required: true,
                    message: `${this.state.requiredText}`,
                  },
                ],
              })(<input type="email" className="signup-form__form-control" />)}
              <div className={getFieldError('email') ? 'error' : 'hidden'}>
                {(getFieldError('email') || []).join(', ')}
              </div>
            </div>
        )}
        <Button type="submit" nature="primary">
          {
            this.state.resetMode
              ? <FormattedMessage id="Form.ResetPassword" defaultMessage="Reset Password" />
              : <FormattedMessage id="Form.ResetLink" defaultMessage="Send Link" />
          }
        </Button>
        <Link to="/apply-now">
          <Text type="small" modifiers="pure-white helper-link" onClick={this.displaySignUp}>
            <FormattedMessage id="SignUpRedirect" defaultMessage="No account? Sign up" />
          </Text>
        </Link>
      </form>
    );
  }
}

const WrappedPasswordResetForm = createForm()(PasswordResetForm);

export default WrappedPasswordResetForm;



// WEBPACK FOOTER //
// ./src/components/HomePage/PasswordResetForm.js